/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { WOMISwapToOMI, WOMISwapToOMIInterface } from "../WOMISwapToOMI";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_omiContractAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_womiContractAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "previousSwapAmount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newSwapAmount",
        type: "uint256",
      },
    ],
    name: "MinimumSwapAmountChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Swap",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumSwapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "omiAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "womiAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newMinimumSwapAmount",
        type: "uint256",
      },
    ],
    name: "setMinumumSwapAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class WOMISwapToOMI__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _omiContractAddress: string,
    _womiContractAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WOMISwapToOMI> {
    return super.deploy(
      _omiContractAddress,
      _womiContractAddress,
      overrides || {}
    ) as Promise<WOMISwapToOMI>;
  }
  getDeployTransaction(
    _omiContractAddress: string,
    _womiContractAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _omiContractAddress,
      _womiContractAddress,
      overrides || {}
    );
  }
  attach(address: string): WOMISwapToOMI {
    return super.attach(address) as WOMISwapToOMI;
  }
  connect(signer: Signer): WOMISwapToOMI__factory {
    return super.connect(signer) as WOMISwapToOMI__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WOMISwapToOMIInterface {
    return new utils.Interface(_abi) as WOMISwapToOMIInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WOMISwapToOMI {
    return new Contract(address, _abi, signerOrProvider) as WOMISwapToOMI;
  }
}
